import React, { useState, useEffect,} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { GpsBaseURL } from '../../api/DataApis';
import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "../Users/User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';



  const Master = () => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [Users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
  const [cities, setcities] = useState([]);
  const [selectedcity, setSelectedcity] = useState("");
  const [SelectedState, setSelectedState] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedUser, setSelectedUser] = useState('');
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });

  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/product-list`);
    }
 

 
  
 
  
  document.title = "Master";





  








  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    const fetchCountriesData = async () => {
      setLoading(true);
      const apiEndpoint = `${BaseURL}/settings/countries`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Countries response", response);
        setCountries(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountriesData();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      if (!selectedCountry) return;
      setLoading(true);
      try {
        const response = await axios.get(`${BaseURL}/settings/states/${selectedCountry?.id}`, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("States response", response);
        setStates(response?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching states:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStates();
  }, [selectedCountry]);

  useEffect(() => {
    const fetchCities = async () => {
      if (!SelectedState) return;
      setLoading(true);
      try {
        const response = await axios.get(`${BaseURL}/settings/cities/${SelectedState?.id}`, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Cities response", response);
        setcities(response?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCities();
  }, [SelectedState]);

  const fetchUsers = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/`);
   
    
    // Prepare query parameters
    const queryParams = [`page=${page}`];
    
    // Add search term to the query params if it's not empty
    // if (searchTerm) queryParams.push(`searchText=${searchTerm}`);
    if (selectedCountry) queryParams.push(`country_id=${selectedCountry?._id}`);
    if (SelectedState) queryParams.push(`state_id=${SelectedState?._id}`);
    if (selectedcity) queryParams.push(`city_id=${selectedcity}`);
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
    if (selectStatusType) queryParams.push(`status=${selectStatusType}`);
    
    
    const apiUrl = `${apiEndpoint}?${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
      setUsers(response.data?.data || []);
      setFilteredData(response.data?.data);
      setTotalCount(response.data.count || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.count / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchUsers(page);
  }, [searchTerm, selectedCountry, SelectedState, selectedcity, page]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  

  
  const handleStatusType = async (event, userId, ) => {
    const status = event.target.value;
  
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    const url = `${BaseURL}/user/change-status/${userId}`;
    //http://localhost:5000/api/admin/user/change-status/66bd306c0b2f0e2ff46a7fde
    
    const formData = new FormData();
    // formData.append("status", status);
  
    try {
      Swal.fire({
        title: 'Processing...',
        text: 'please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await axios.put(url,
        
        {"status" : status}, {
        headers: {
          "Content-Type": "Application/json",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      if (response.data.statusCode === 200) {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.close();
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      Swal.close();
      console.error("Error updating status:", error);
    }
  };

  const handleSelectChange = async (userId, username, walletAmount) => {
    setSelectedUser(userId);
  
    Swal.fire({
      title: `Assign Balance`,
      html: `
        <span>Name: </span><b>${username}</b><br><br>
        <span>Current Wallet Amount: </span><b>₹${walletAmount}</b><br><br>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <label for="swal-input1" style="width: 100px;">Add Wallet Amount:</label>
          <input type="number" id="swal-input1" class="swal2-input" style="width: 200px;" placeholder="Enter additional amount" />
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <label for="swal-input2" style="width: 100px;">Password:</label>
          <input type="text" id="swal-input2" class="swal2-input" style="width: 200px;" placeholder="Enter password" />
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const additionalAmount = document.getElementById('swal-input1').value;
        const password = document.getElementById('swal-input2').value;
  
        if (!additionalAmount || !password) {
          Swal.showValidationMessage('Please fill in both fields');
          return false;
        }
  
        return { additionalAmount, password, userId };
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const { additionalAmount, password, userId } = result.value;
  
        const addedAmount = parseFloat(additionalAmount);
        const existingAmount = parseFloat(walletAmount);
        const updatedAmount = existingAmount + addedAmount;
  
        Swal.fire({
          title: 'Processing...',
          text: 'Please wait',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
  
        try {
          const response = await axios.put(`${BaseURL}/user/update-wallet/${userId}`, {
            amount: addedAmount,
            password: password
          }, {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${uniqueToken}`,
            },
          });
  
          const successResponse = await response.data;
  
          Swal.close();
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: successResponse.message || 'User assigned successfully!',
          });
  
          // Manually refetch users after the update
          fetchUsers(page);  // Refetch users to ensure the updated amount is displayed
  
        } catch (error) {
          Swal.close();
          let errorMessage = 'An error occurred while assigning user.';
          if (error.response) {
            const errorResponse = await error.response.data;
            errorMessage = errorResponse.message || errorMessage;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
          });
        }
      }
    });
  };
  
  
  
 const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/product/?page=${page}`;
  //let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/`);
  const params = [];

  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
//   if (selectedStatusType) {
//     params.push(`status=${selectStatusType}`);
// }

  // Add selected country, state, and city to the params
  // if (selectedCountry?._id) {
  //     params.push(`country_id=${selectedCountry._id}`);
  // }
  // if (SelectedState?._id) {
  //     params.push(`state_id=${SelectedState._id}`);
  // }
  // if (selectedcity) {
  //     params.push(`city_id=${selectedcity}`);
  // }

  // // Append query parameters to the URL
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.data?.length); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.totalCount / Limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};







  
  


  console.log("users", Users);
  console.log("totalCount", totalCount);
  console.log("pagecount", pageCount);
  console.log("limit", Limit);
  console.log("filtredDataaasss", filteredData);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Masters({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>
  
  <Link
    className="btn btn-transparent grey-salsa btn-outline btn-sm"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      display: "inline-flex",
      alignItems: "center",
      overflow: "hidden",
    }}
    to="/product-add"
  >
    <i className="fa fa-plus"></i> Add Product
  </Link>
</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        //gap: "10px", // Consistent spacing between filters
        flexWrap: "wrap", // Allow wrapping on smaller screens
      }}
    >
<div className="col-md-2 col-sm-12">
  <div className="form-group">
  <input
    placeholder="Find Data Here"
    className="form-control"
    style={{
      //width: "calc(100% - 150px)", // Increased available width for the input box
      borderRadius: "8px",
      padding: "6px 10px",
      marginRight: "10px",
      height: "38px", // Consistent height
    }}
    value={searchQuery}
    onChange={handleSearchTextChange}
  />
  </div>
</div>





<div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>

    {/* Search Button */}
    <button
      className="btn btn-primary"
      onClick={handleSearchSubmit} // Calls the handleSearchSubmit function
      style={{
        marginLeft: "10px", // Space between the input and button
        height: "38px", // Consistent height
        width: "80px", // Consistent width for the Search button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Search
    </button>

    {/* Reset Button */}
    <button
      className="btn btn-primary"
      onClick={handleReset} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Reset
    </button>

</div>

    </div>
  </form>
</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Corporate Name</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Title</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Stock</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Description</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created By</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created At</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Product Image</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Action</th>
  
 
  </tr>
</thead>

        <tbody> 
          {filteredData?.map((user, index) => (
            <tr key={index}>
              <td>{(page - 1) * Limit + index + 1}</td>
         <td>{user?.corporate_name}</td>
       <td>{user?.title}</td>
       <td>+{user?.stock}</td>
       <td>{user?.description}</td>
       <td>{user?.created_by}</td>
       <td>{user?.createdAt}</td>
       <td>
  {user?.product_image ? (
    <img src={user.product_image} alt="Admin image" style={{ width: '100px', height: 'auto' }} />
  ) : (
    <span style={{ color: 'red' }}></span>
  )}
</td>
  <td style={{ whiteSpace: 'nowrap' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Link to={`/product-edit/${user?._id}`} state={{ CorporateEditData: user }}>
                  <i className="fa fa-edit"
                   title="Edit User"
                  ></i>
                </Link>
                &nbsp;&nbsp;&nbsp;
                <Link to={`/product-view/${user?._id}`} state={{ UserViewData: user }}>
                  <i className="fa fa-eye"
                   title="View User"
                  ></i>

                </Link>
                &nbsp;&nbsp;
           </td>               
            </tr>
          ))}   
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default Master;
